import { render, staticRenderFns } from "./pb-manage.vue?vue&type=template&id=0a355e3f&scoped=true"
import script from "./pb-manage.vue?vue&type=script&lang=js"
export * from "./pb-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a355e3f",
  null
  
)

export default component.exports